import { useQuery } from "react-query";
import AttributeDataService from "../../services/attribute-data-service/AttributeDataService";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";
import { IAttributeUsage } from "../../services/attribute-data-service/Models";

export type UseAttributesUsageParameters = {
    organizationID: number,
    groupID: number,
    attributeName?: string

} & BaseUseQueryParameters<IAttributeUsage[] | undefined>;

export function useAttributesUsage({
    organizationID,
    groupID,
    attributeName,
    enabled,
    onError,
    onSuccess,
}: UseAttributesUsageParameters) {
    return useQuery<IAttributeUsage[], RestError>(
        keys.attributesUsage(organizationID, groupID, attributeName),
        ({ signal }) => {
            return AttributeDataService.getAttributesUsage(
                organizationID,
                groupID, 
                attributeName,
                signal
            );
        },
        {
            enabled,
            onError: onError,
            onSuccess: onSuccess,
            refetchInterval: false,
            staleTime: Infinity
        }
    );
}